import React, { useState, useEffect } from 'react';
import './Navbar.css';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const closeMenu = () => {
    setIsMenuOpen(false);
  }

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <a href="#landing" className="navbar-logo">MG</a>
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <a href="#about" className="navbar-link" onClick={closeMenu}>About</a>
          <a href="#experience" className="navbar-link" onClick={closeMenu}>Experience</a>
          <a href="#projects" className="navbar-link" onClick={closeMenu}>Projects</a>
          <a href="#contact" className="navbar-link" onClick={closeMenu}>Contact</a>
          <a 
            href="https://drive.google.com/file/d/1FG0oKq9gI4kqcE1biMrNVNgKGtHby5XX" 
            className="navbar-resume-button" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Resume
          </a>
        </div>
        <div className="navbar-toggler" onClick={toggleMenu}>
          <i className={isMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
